import { render } from "./PublishAPlan.vue?vue&type=template&id=993a7082"
import script from "./PublishAPlan.vue?vue&type=script&lang=js"
export * from "./PublishAPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/results/PublishAPlan.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "993a7082"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('993a7082', __exports__)) {
    api.reload('993a7082', __exports__)
  }
  
  module.hot.accept("./PublishAPlan.vue?vue&type=template&id=993a7082", () => {
    api.rerender('993a7082', render)
  })

}


export default __exports__